<template>
    <div class="c-switch-header" v-if="!isInitialAddressesFetch">
        <h3 class="c-switch-header__title">{{ headerTitle }}</h3>
        <button
            id="js-switch-modal-close"
            class="c-switch-header__close"
            @click="closeModal"
            v-if="isEmptyCart && shopType === 'b2c'"
        >
            <i class="ico ico-close"></i>
        </button>

        <div class="c-switch-header__tabs" v-if="showTabs">
            <AddressTabs />
        </div>

        <div class="c-switch-header__address" v-else>
            <div class="c-switch-header__address__text" v-html="formattedSelectedAddress"></div>

            <div class="c-switch-header__address__link">
                <button
                    type="button"
                    class="c-link c-link--secondary is-underlined"
                    @click="setTabsVisibility(true)"
                >
                    {{ $t("Switch.Addresses.change") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AddressTabs from "./AddressTabs.vue";

export default {
    components: {
        AddressTabs,
    },
    methods: {
        setTabsVisibility(value) {
            this.$store.commit("SET_WANNA_CHANGE_ADDRESS", value);
        },
        closeModal() {
            $("#switch-modal").modal("hide");
        },
    },
    created() {
        if (typeof rEvent.on === "function") {
            rEvent.on("Cart.product.after_add", (response) => {
                this.$store.commit("SET_EMPTY_CART", false);
            });
        }
    },
    computed: {
        ...mapState([
            "isInitialAddressesFetch",
            "autocompleteAddressIsUsed",
            "isEmptyCart",
            "shopType",
        ]),
        ...mapGetters(["showTabs", "selectedAddress", "headerTitle"]),
        formattedSelectedAddress() {
            if (this.autocompleteAddressIsUsed) {
                return this.selectedAddress;
            }

            return this.selectedAddress?.address || '';
        },
    },
};
</script>
